import { z } from 'zod'

export const globalSchema = {
  mysqlCHAR: z.string(),
  mysqlVARCHAR: z.string(),
  mysqlTINYINT: z.number(),
  mysqlTEXT: z.string(),
  mysqlDECIMAL: z.number(),
  mysqlSMALLINT: z.number(),
  mysqlDATETIME: z.union([z.date(), z.literal('0000-00-00 00:00:00')]),
  mysqlINT: z.number(),
  mysqlBIGINT: z.number(),
  mysqlFLOAT: z.number(),
  mysqlTIMESTAMP: z.date(),
  mysqlBLOB: z.unknown(),
  mysqlDATE: z.union([z.date(), z.literal('0000-00-00')]),
}
